var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6095_49057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 9.9974C18.3333 14.5998 14.6024 18.3307 10 18.3307M18.3333 9.9974C18.3333 5.39502 14.6024 1.66406 10 1.66406M18.3333 9.9974H1.66667M10 18.3307C5.39763 18.3307 1.66667 14.5998 1.66667 9.9974M10 18.3307C12.0844 16.0488 13.269 13.0874 13.3333 9.9974C13.269 6.90742 12.0844 3.94602 10 1.66406M10 18.3307C7.9156 16.0488 6.73104 13.0874 6.66667 9.9974C6.73104 6.90742 7.9156 3.94602 10 1.66406M1.66667 9.9974C1.66667 5.39502 5.39763 1.66406 10 1.66406",
    stroke: "#4A5564",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6095_49057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.96b51d3a.svg";
export { ForwardRef as ReactComponent };